import { type FC } from 'react'
import { ConversationContentDefault } from './ConversationContentDefault'
import { ConversationContentVirtualize } from './ConversationContentVirtualize'

type IConversationContentProps = {
  virtualized?: boolean
}

export const ConversationContent: FC<IConversationContentProps> = ({ virtualized }) =>
  virtualized ? <ConversationContentVirtualize /> : <ConversationContentDefault />
